/* eslint-disable react/prop-types */
import React from 'react';

import { InfoItem } from '@molecules';
import { useMedia } from '@api/hooks';
import { getImage } from '@utils/media';

const ListItem = ({ item }) => {
  const { media, ...mediaQuery } = useMedia(getImage(item));

  const imageName = (mediaQuery.isFetching && 'Loading ...') || mediaQuery.error?.message || media.title;

  return <InfoItem image={media.src}>{imageName}</InfoItem>;
};

export default ListItem;
